import React, { useMemo } from "react";
import { FieldValues } from "react-hook-form";
import FingridTestGenericPlanningsForm from "../shared/FingridTestGenericPlanningsForm";
import { computeDefaultValuesFcrN, toGenericFcrNConfigs } from "./configAdapter";

export interface PlanningFormProps {
  initialData: FieldValues;
}

const TestFcrNPlanningsForm: React.FC<PlanningFormProps> = ({ initialData }) => {
  const defaultValues = useMemo(() => computeDefaultValuesFcrN(initialData), [initialData]);
  const genericConfigs = useMemo(() => toGenericFcrNConfigs(), []);

  return (
    <FingridTestGenericPlanningsForm
      initialData={initialData}
      configs={genericConfigs}
      defaultValues={defaultValues}
      lockSocEndDate
    />
  );
};

export default TestFcrNPlanningsForm;
